import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'practica-faculty-card',
  templateUrl: './faculty-card.component.html',
  styleUrls: ['./faculty-card.component.scss']
})
export class FacultyCardComponent implements OnInit {

  @Input() facultyName;
  @Input() facultyImage;
  @Input() routerUrl;
  constructor() { }

  ngOnInit(): void {
  }

}
